<template>
  <div class="jobs-dialog-container">
    <img
      class="jobs-dialog-container__notification-icon"
      src="@/assets/flying-logo.gif"
      alt="background"
      @click="onClickIcon"
    />
    <JobsDrawer v-model="drawerValue" @close="onClose" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";

import JobsDrawer from "@/components/drawers/JobsDrawer.vue";

export default Vue.extend({
  name: "JobsDialog",
  components: { JobsDrawer },

  data() {
    return {
      drawerValue: false,
    };
  },

  methods: {
    onClose(): void {
      this.drawerValue = false;
    },
    onClickIcon(): void {
      this.drawerValue = true;
    },
  },
});
</script>

<style lang="scss" scoped>
.jobs-dialog-container {
  position: absolute;
  right: 20px;
  bottom: 90px;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;

  &__notification-icon {
    cursor: pointer;
    height: 100px;
    width: 100px;
  }
}
</style>
